import { COVERAGE_TABS } from '../../../../constants';
import { TRACKING_SUB_AREA } from '../../../../trackingV2';
import { createCoverageSelector, createCoverageParamsSelector } from '../../../common/coverage/selectors';
import * as filtersSelectors from '../../filters/selectors';

export const getDeviceCoverage = (store) => store.apps.analytics.rdc.coverage.device;

export const deviceCoverageSelector = createCoverageSelector({
  coverageStore: getDeviceCoverage,
  source: 'rdc',
  productSubArea: TRACKING_SUB_AREA[COVERAGE_TABS.devices.trackEvent],
});

export const getParams = createCoverageParamsSelector(
  filtersSelectors.getCoverageFiltersParams,
  getDeviceCoverage,
);
